<template>
  <div class="background-color">
    <div class="container">
      <div class="space-50"></div>
      <div class="row justify-content-center">
        <div class="text-center text-color-title">
          <h2><strong>Envíanos tus dudas y comentarios</strong></h2>
          <p>Una buena relación comienza con una buena comunicación</p>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-2">
          <div>
            <img class="comillas" src="../../assets/assets_loyalty/comillas-33.png">
          </div>
        </div>
        <div class="col-md-8">
          <div class="text-center">
              <div class="row">
                <div class="col-sm-4">
                  <input  v-model="nameContact" class="input-section" type="text" placeholder="Nombre" required>
                </div>
                <div class="col-sm-4">
                  <input v-model="numberContact" class="input-section" type="number" placeholder="Telefono" required>
                </div>                
                <div class="col-sm-4">                  
                  <input v-model="emailContact" class="input-section" type="email" placeholder="Correo electrónico" required>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-sm-4">
                  <textarea v-model="messageContact" class="textarea-section" rows="5" placeholder="Comentarios" required></textarea>
                </div>
              </div>
              <div class="alert-success">{{sentSuccessfull}}</div>
              <div class="alert-danger">{{sentError}}</div>
              <div class="row">
                <div class="col-sm-6">
                  <vue-recaptcha class="captcha" ref="recaptcha" @verify="markRecaptchaAsVerified" sitekey="6LdlXLwUAAAAAHouUjujMEM-7Ec4_Gz0RkDmS5Xv" :loadRecaptchaScript="true"></vue-recaptcha>
                </div>
                <div v-if="!showBotton" class="col-sm-6">
                  <button class="send-button"  @click="checkForm">Enviar</button>
                </div>
                <div v-if="showBotton" class="col-sm-6">
                  <button class="send-button-loader">
                    <img class="loader-gif" src="../../../public/img/Rolling.gif">
                  </button>
                </div>
              </div>
          </div>
        </div>
        <div class="col-md-2">
          <div>
            <img class="comillas" src="../../assets/assets_loyalty/comillas-32.png">
          </div>
        </div>
      </div>
      <div class="space-50"></div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';
// import axios from "axios";
import VueRecaptcha from 'vue-recaptcha';
import LoginService from '../../service/core/login.service';


export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    VueRecaptcha
  },
  data(){
    return {
      loginService: new LoginService(),
      nameContact: '',
      showBotton: false,
      emailContact: '',
      numberContact: '',
      messageContact: '',
      sentSuccessfull: '',
      sentError: '',
      recaptchaVerified: false,
    }
  },
   methods:{
     markRecaptchaAsVerified(response) {
      this.recaptchaVerified = true;
    },
    checkForm(e) {
      let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i
      this.showBotton = true
      if(this.nameContact === ''){
        this.showBotton = false
        this.sentError = 'Por favor, llene todos los campos'
        this.sentSuccessfull = ''
      }else if(this.emailContact === '' ){
        this.showBotton = false
        this.sentError = 'Por favor, llene todos los campos'
        this.sentSuccessfull = ''
      }else if(!emailRegex.test(this.emailContact)){
        this.showBotton = false
        this.sentError = 'Por favor, introduzca un correo valido'
        this.sentSuccessfull = ''
      }else if(this.numberContact === ''){
        this.showBotton = false
        this.sentError = 'Por favor, llene todos los campos'
        this.sentSuccessfull = ''
      }else if(this.messageContact === ''){
        this.showBotton = false
        this.sentError = 'Por favor, llene todos los campos'
        this.sentSuccessfull = ''
      }else if(this.recaptchaVerified === false){
        this.showBotton = false
        this.sentError = 'Por favor, marque el captcha'
        this.sentSuccessfull = ''
      }else{
        let conditions = {
          "contact":{
            "name": this.nameContact,
            "phone": this.numberContact,
            "email": this.emailContact,
            "comments": this.messageContact
          }
        }
        this.loginService.contact(conditions).then(data => {
          this.sentSuccessfull = "¡Gracias por tu tiempo! Nos comunicaremos contigo lo antes posible"
          this.sentError = ''
          this.nameContact = '',
          this.emailContact = '',
          this.numberContact = '',
          this.messageContact = '',
          this.showMessage = true
          this.showBotton = false
        }, err =>{
          this.showBotton = false
          this.sentError = '¡Ups! Algo salio mal, intentalo de nuevo'
        })
      }
    }
  }
}
</script>
<style>
.background-color{
    background-color: #0069A9;
}
.text-color-title{
  color: white;
}
.input-section{
  width: 230px;
  padding: 8px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
}
.textarea-section{
  width: 740px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
}
.captcha{
  margin: 10px 0px 0px 35px ;
}
.send-button{
  width: 100%;
  margin-top: 10px;
  height: 50px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000; 
  background-color: #ea5b0c;
  color: #ffffff;
  font-weight: bold;
}
.send-button-loader{
  width: 100%;
  margin-top: 10px;
  height: 50px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000; 
  background-color: #f0f0f0;
  color: #ffffff;
  font-weight: bold;
}
@media screen and (min-width: 321px) and (max-width: 768px) { 
  .input-section{
    width: 300px;
    margin: 10px;
    padding: 8px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
  }
  .textarea-section{
    width: 300px;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
  }
  .captcha{
    margin: 10px 0px 30px 25px ;
  }
  .comillas{
    display: none;
  }
}
</style>
